// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__FiaL-"};